import React from 'react'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import { useDispatch } from 'react-redux'
import { trackButtonClicked, UPGRADE_NOW, BANNER } from '../../Services/Analytics/TrackEventsService'

const styles = theme => ({
  button: {
    marginRight: 10
  }
})

const UpgradeButton = ({ onBarClick, classes }) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(trackButtonClicked(UPGRADE_NOW, { button_location: BANNER, pathname: window.location.pathname }))
    onBarClick()
  }

  return (
    <Button
      variant='contained'
      color='primary'
      onClick={handleClick}
      className={classes.button}>
      upgrade now
    </Button>
  )
}

export default withStyles(styles)(UpgradeButton)
